// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import TitledCard from 'common/components/cards/TitledCard';
import { ChromePicker } from 'react-color';
import FileUploadButton from './FileUploadButton';
import { Label, ColorPickerContainer, MargedBlock } from '../../styles';
import type { StatsRadioPlayerData } from '../../../domain/PlayerConfiguration';
import HeaderDemo from './demos/HeaderDemo';

type Props = {
  data: StatsRadioPlayerData;
  onValueChange: (key: string, color: string) => void;
  onThemeChange: (key: string, data: Object) => void;
  onBackgroundColorChange: (color: string) => void;
  t: any;
  theme: Object;
}

type State = {
  backgroundColor: string,
  textColor: string,
  iconBackgroundColor: string,
  iconTextColor: string,
}

class Theme extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      backgroundColor: props.data.theme.header.backgroundColor,
      textColor: props.data.theme.stationInformation.textColor,
      iconTextColor: props.data.theme.header.iconColor,
      iconBackgroundColor: props.data.theme.header.buttonColor,
    };
  }

  onColorChange(key, color) {
    this.setState({
      ...this.state,
      [key]: color.hex,
    });
  }

  onColorChangeComplete(key, colorKey, color) {
    const data = {
      ...this.props.data.theme[key],
      [colorKey]: color.hex,
    };

    this.props.onThemeChange(key, data);
  }

  render() {
    const { data, t } = this.props;
    const { backgroundColor, iconBackgroundColor, iconTextColor, textColor } = this.state;

    return (
      <TitledCard title={t('theme')}>
        <div className="row">
          <div className="col-xs-6">
            <Label>{t('logo')}</Label>
            <FileUploadButton
              onUpload={file => this.props.onValueChange('logo', file)}
              label={t('add')}
            />
          </div>
          <div className="col-xs-6">
            <HeaderDemo
              className="col-xs-6"
              colors={this.state}
              data={data.stationInformation}
            />
          </div>
        </div>
        <MargedBlock className="row">
          <ColorPickerContainer className="col-xs-4 col-md-3">
            <Label withPadding>{t('backgroundColor')}</Label>
            <ChromePicker
              color={backgroundColor}
              onChange={color => this.onColorChange('backgroundColor', color)}
              onChangeComplete={color => this.props.onBackgroundColorChange(color.hex)}
            />
          </ColorPickerContainer>
          <ColorPickerContainer className="col-xs-4 col-md-3">
            <Label withPadding>{t('mainTextColor')}</Label>
            <ChromePicker
              color={textColor}
              onChange={color => this.onColorChange('textColor', color)}
              onChangeComplete={color => this.onColorChangeComplete('stationInformation', 'textColor', color)}
            />
          </ColorPickerContainer>
          <ColorPickerContainer className="col-xs-4 col-md-3">
            <Label withPadding>{t('iconBackgroundColor')}</Label>
            <ChromePicker
              color={iconBackgroundColor}
              onChange={color => this.onColorChange('iconBackgroundColor', color)}
              onChangeComplete={color => this.onColorChangeComplete('header', 'buttonColor', color)}
            />
          </ColorPickerContainer>
          <ColorPickerContainer className="col-xs-4 col-md-3">
            <Label withPadding>{t('iconTextColor')}</Label>
            <ChromePicker
              color={iconTextColor}
              onChange={color => this.onColorChange('iconTextColor', color)}
              onChangeComplete={color => this.onColorChangeComplete('header', 'iconColor', color)}
            />
          </ColorPickerContainer>
        </MargedBlock>
      </TitledCard>
    );
  }
}

export default withTheme(translate('radioConfiguration')(Theme));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/Theme.js